import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <Link to="/">
            <img src="/vertech-logo-wide.png" alt="VerTechnology" className="logo-image" />
          </Link>
        </div>
        
        <nav className={`header-nav ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/services/technology" className="nav-link">Technology Services</Link>
          <Link to="/services/software" className="nav-link">Software Services</Link>
          <Link to="/services/intelligence" className="nav-link">Intelligence Services</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
          <Link to="/resources" className="nav-link">Resources</Link>
        </nav>

        <div className="header-actions">
          <Link to="/contact" className="btn-primary">Contact Sales</Link>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
